<template>
	<div class="financial-table-cost-header" style="page-break-inside: avoid">
		<v-layout row wrap>
			<v-flex d-flex xs1>
				<v-card tile :color=parseColorValue(-1) class="financial-table-header-color">
					<v-card-text class="financial-summary-first-cell">

					</v-card-text>
				</v-card>
			</v-flex>

			<v-flex d-flex xs1 v-for="(value,index) in cellsValues" :key="index">
				<v-card tile :color=parseColorValue(0) class="financial-table-header-color">
					<v-card-text :style="cellTextStyle" class="financial-table-header-small-font-size">
						<strong>
							{{value}}
							<financial-table-cost-headers-warning
								v-if="showFinancialTableCostWarnings && showWarning(value, index)"/>
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import FinancialTableCostHeadersWarning from "./FinancialTableCostHeadersWarning";

	export default {
		name: 'financial-table-cost-headers',
		components: {FinancialTableCostHeadersWarning},

		data () {
			return {
				cellsValues: ['koszt całkowity',
					'z dotacji',
					'z innych źródeł finansowych',
					'wkład osobowy',
					'wkład rzeczowy',
					'całkowite wydatki',
					'z dotacji',
					'z innych źródeł finansowych',
					'wkład osobowy',
					'wkład rzeczowy',
					'z odsetek od dotacji lub pozostałych przychodów']
			};
		},

		computed: {
			cellTextStyle () {
				return "padding-left: 5px; padding-right: 5px; text-align: center";
			}
		},

		methods: {
			parseColorValue (val) {
				if (val < 0) {
					return "grey darken-" + (-val);
				}
				return "grey lighten-" + val;
			},

			showWarning (value, index) {
				if (index >= 5 && index <= 9) {
					switch (value) {
						case 'całkowite wydatki':
							return parseFloat(this.values.sumFromDocument.toFixed(2)) > parseFloat(this.values.sumFromProject.toFixed(2));
						case 'z dotacji':
							return parseFloat(this.values.dotationFromDocument.toFixed(2)) > parseFloat(this.values.dotationFromProject.toFixed(2));
						case 'z innych źródeł finansowych':
							return parseFloat(this.values.otherFromDocument.toFixed(2)) > parseFloat(this.values.otherFromProject.toFixed(2));
						case 'wkład osobowy':
							return parseFloat(this.values.humanFromDocument.toFixed(2)) > parseFloat(this.values.humanFromProject.toFixed(2));
						case 'wkład rzeczowy':
							return parseFloat(this.values.contributionFromDocument.toFixed(2)) > parseFloat(this.values.contributionFromProject.toFixed(2));
						default:
							return false;
					}
				}
				return false;
			}
		},

		props: {
			showFinancialTableCostWarnings: {type: Boolean, default: false},
			values: {type: Object}
		}
	};
</script>

<style>
@media print {
	.financial-table-cost-header > .d-flex strong {
		line-height: 13px;
		font-size: 8px;
	}
	.financial-table-cost-header > .d-flex .v-card__text {
		padding: 5px 2px !important;
	}
}
</style>